import { gql, TypedDocumentNode } from '@apollo/client'
import type { EmployeeWorkProfileFragment } from './__generated__/EmployeeWorkProfileFragment'

export const employeeWorkProfileFragment: TypedDocumentNode<EmployeeWorkProfileFragment> = gql`
  fragment EmployeeWorkProfileFragment on EmployeeWorkProfile {
    bankAccount
    bic
    childrenNumber
    childrenWithDisabilitiesNumber
    dependentPersonsNumber
    dependentPersonsWithDisabilitiesNumber
    flexiNotAllowedUntil
    hoursContingent
    involuntaryPartTime
    isRetired
    maritalDate
    maritalState
    remainingHours
    remainingHoursScrapedAt
    residencePermitBackPicture
    residencePermitCode
    residencePermitExpiresOn
    residencePermitFrontPicture
    retiredOn
    taxCode
    workPermitBackPicture
    workPermitExpiresOn
    workPermitFrontPicture
  }
`
